import React, { useEffect, useState } from "react";
import DTOSkillsDetails from "./DTOSkillsDetails";
import SkillDetailsPresenter from "./SkillDetailsPresenter";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import {
  getAllEmployeeSkills,
  resetEmployeeSkills,
} from "../../../../infra/aggregates/myProfile/skillsSlice";
import { useAppSelector, useAppDispatch } from "../../../../infra/hooks";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
function SkillsDetailsController() {
  const { t } = useTranslation();
  const empId: number = useAppSelector((state) => state.authSlice.emp_id);
  const [skillsData, setSkillData] = useState([]);
  const dispatch = useAppDispatch();
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  function callBackFunc(data: any) {
    setSkillData(data);
  }

  /* Call Back Function to get Item to be --DELETED-- && --EDITED-- in Skills*/
  const getSkillIdItemToBeDeleted = async (skill_id: number) => {
    const response: any =
      await updatePersonalDetailsService.deleteEmployeeSkill(empId, skill_id);

    if (response.status == "success") {
      toast.success(t("Deleted Successfully"));
      dispatch(getAllEmployeeSkills(response?.data));
    }
  };

  const getEditedPayload = async (edit_payload: any) => {
    const response: any =
      await updatePersonalDetailsService.updateEmployeeSkill(edit_payload);
    if (response.status == "success") {
      dispatch(getAllEmployeeSkills(response?.data));
      toast.success(t("Updated Successfully"));
    }
  };
  return (
    <div>
      <DTOSkillsDetails getSkillsData={callBackFunc} />
      <SkillDetailsPresenter
        allSkillsData={skillsData}
        onDeleteSkill={getSkillIdItemToBeDeleted}
        onEditSkill={getEditedPayload}
        hr_view={hr_view}
        trans={t}
      />
    </div>
  );
}

export default SkillsDetailsController;
